import React, { Component } from 'react';
import PropTypes from 'prop-types';
import raf from 'raf';
import Curtain from '../heatmap/Curtain';
import debounce from 'lodash/debounce';
import flipInvert from '../../../utils/flipInvert';
import MeasureScrollBar from '../../../utils/MeasureScrollBar';

const scrollBarMeasurer = new MeasureScrollBar();

export const ANIMATION_DURATION = 500;

class Popup extends Component {
  render() {
    return this.props.isOpen ? (
      <Curtain isOpen={true}>
        <PopupWidget {...this.props} />
      </Curtain>
    ) : null;
  }
}

Popup.propTypes = {
  isOpen: PropTypes.bool,
};

export default Popup;

export class PopupWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animate: false,
      hasAnimated: false,
      canvasHeight: null,
      show: false,
      transform: '',
    };
    this.debouncedHandleResize = debounce(this.handleResize.bind(this), 200);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  componentDidMount() {
    $(window)
      .on('resize', this.debouncedHandleResize)
      .on('keydown', this.handleKeydown);
    const scrollBarWidth = scrollBarMeasurer.getWidth();
    $(document.body)
      .addClass('o-h')
      .css({ paddingRight: scrollBarWidth });
    this.animateInitialState();
  }

  componentWillUnmount() {
    $(window)
      .off('resize', this.debouncedHandleResize)
      .off('keydown', this.handleKeydown);
    $(document.body)
      .removeClass('o-h')
      .css({ paddingRight: 0 });
  }

  animateInitialState() {
    const canvasSize = this.getCanvasSize();
    this.setState({ ...canvasSize }, this.beginAnimateInitialState);
  }

  beginAnimateInitialState() {
    raf(this.zoomImg.bind(this));
  }

  zoomImg() {
    const imgBox = this.img.getBoundingClientRect();
    this.setState(
      { ...this.setIntialTransform(imgBox) },
      this.beginZoomImg.bind(this, imgBox)
    );
  }

  beginZoomImg(imgBox) {
    raf(this.animateZoomImg.bind(this, imgBox));
  }

  animateZoomImg(imgBox) {
    this.animate();
    this.setDomain(imgBox);
  }

  handleResize() {
    const { width, height } = this.getCanvasSize();
    this.setState({ width, height }, this.postResize);
  }

  postResize() {
    raf(this.cleanupResize.bind(this));
  }

  cleanupResize() {
    const imgBox = this.img.getBoundingClientRect();
    this.setDomain(imgBox);
  }

  handleKeydown(e) {
    // ESC
    if (e.keyCode === 27) {
      this.props.onCloseClick && this.props.onCloseClick();
    }
  }

  setIntialTransform(last) {
    const first = this.props.promptBbox;
    const { matrix } = flipInvert(first, last);
    const transform = matrix;
    return {
      show: true,
      transform,
    };
  }

  getCanvasSize() {
    // we know the size and width the image wants to take up, we can do the math ourselves!
    const width = +this.props.dimensions.full.width;
    const height = +this.props.dimensions.full.height;
    const {
      width: availableWidth,
      height: availableHeight,
    } = this.imgWrapper.getBoundingClientRect();
    const wRatio = width / availableWidth;
    const hRatio = height / availableHeight;

    const resizeFactor =
      wRatio <= 1 && hRatio <= 1 ? 1 : hRatio >= wRatio ? hRatio : wRatio;

    return { width: width / resizeFactor, height: height / resizeFactor };
  }

  setDomain(imgBox) {
    if (this.props.setDomain) {
      this.props.setDomain(imgBox);
    }
  }

  animate() {
    raf(this.beginAnimate.bind(this));
  }

  beginAnimate() {
    this.setState(
      {
        animate: true,
        hasAnimated: true,
        transform: null,
      },
      this.postAnimate
    );
  }

  postAnimate() {
    setTimeout(this.cleanUpAnimate.bind(this), ANIMATION_DURATION);
  }

  cleanUpAnimate() {
    this.setState({ animate: false });
  }

  getRef(node) {
    this.node = node;
  }

  getImgWrapperRef(node) {
    this.imgWrapper = node;
  }

  getImgRef(node) {
    const { getImgRef } = this.props;
    this.img = node;
    getImgRef && getImgRef(node);
  }

  render() {
    const { children, toolbarHeight = 10, url } = this.props;
    const { animate, hasAnimated, show, transform, width, height } = this.state;

    return (
      <div
        ref={this.getRef.bind(this)}
        style={{
          opacity: show ? 1.0 : 0.001,
          width: '100%',
          height: '100%',
        }}
      >
        <div
          className="d-flex jc-center align-center fd-col imgWrapper"
          ref={this.getImgWrapperRef.bind(this)}
          style={{
            position: 'absolute',
            top: `${toolbarHeight}px`,
            left: 0,
            right: 0,
            bottom: 0,
          }}
        >
          <div
            className="pos-r d-ib"
            style={{
              height: height ? `${height}px` : null,
              width: width ? `${width}px` : null,
              maxWidth: '100%',
              maxHeight: '100%',
              transform,
              transformOrigin: '0 0',
              transition: animate ? 'all .5s ease' : null,
            }}
          >
            {children}
            <img
              crossOrigin="Anonymous"
              ref={this.getImgRef.bind(this)}
              src={url}
              className="mb0"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                visibility: hasAnimated ? null : 'hidden',
              }}
              width={width}
              height={height}
            />
          </div>
        </div>  
      </div>
    );
  }
}

PopupWidget.defaultProps = {
  toolbarHeight: 10,
};
